import React from 'react';

export type ButtonProps = React.ComponentProps<"button"> & {
  variant?: 'primary' | 'secondary' | 'accent' | 'outline' | 'glass';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  children: React.ReactNode;
};

export function Button({ 
  variant = 'primary', 
  size = 'md', 
  className = '', 
  children, 
  ...props 
}: ButtonProps) {
  const baseStyle = "inline-flex items-center justify-center font-medium rounded-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2";
  
  const variants = {
    primary: "bg-cta text-white hover:bg-black focus:ring-gray-900 shadow-sm",
    secondary: "bg-white text-primary border border-gray-200 hover:bg-gray-50 focus:ring-gray-200 shadow-sm",
    accent: "bg-accent text-white hover:bg-accent-hover focus:ring-accent shadow-md",
    outline: "border-2 border-primary text-primary hover:bg-primary hover:text-white focus:ring-primary",
    glass: "bg-white/5 backdrop-blur-sm border border-white/30 text-white hover:bg-white hover:!text-primary focus:ring-white shadow-sm"
  };

  const actualSizes = {
    sm: "px-3 py-1.5 text-xs sm:px-4 sm:py-2 sm:text-sm",
    md: "px-4 py-2 text-sm sm:px-6 sm:py-3 sm:text-base",
    lg: "px-6 py-3 text-base sm:px-8 sm:py-4 sm:text-lg"
  };

  return (
    <button 
      className={`${baseStyle} ${variants[variant]} ${actualSizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
